import { Button } from '@mantine/core';
import { IconFileTypeXls } from '@tabler/icons-react';

import { Id } from '@feature/utils';

interface EvaluationAnnex1ButtonProps {
  evaluationId: Id;
}

const onDownload = (evaluationId: Id) => {
  window.open(`/api/gov-evaluation/${evaluationId}/download-annex-1-xlsx`);
};

export function GovEvaluationAnnex1Button({ evaluationId }: EvaluationAnnex1ButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypeXls size="24px" />}
      onClick={() => onDownload(evaluationId)}
    >
      Descarcă anexa 1
    </Button>
  );
}
